module.exports = "button{width:100% !important}\n"